import {
  Component,
  Input,
  OnInit,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { BaseChartDirective, Label } from "ng2-charts";
import { ChartOptions, ChartType, ChartDataSets, Chart } from "chart.js";
import { NbDialogService } from "@nebular/theme";
import { AuthRoles_PTBR } from "../../model/AuthRoles";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "auth-type-counter-chart",
  templateUrl: "./auth-type-counter-chart.component.html",
  styleUrls: ["./auth-type-counter-chart.component.css"],
})
export class AuthTypeCounterChartComponent implements OnInit {
  @Input()
  public dateChartLabels: any[] = [];

  @Input()
  public countChartData: any[] = [];

  @Input()
  public loadingChartData: boolean;

  @Input()
  public changeTypeChart: ChartType;

  public spinner: boolean;

  public containsAccessData: boolean;

  public chartType: ChartType = "doughnut";
  
  public chartPlugins = [];

  public donutColors=[
    {
      backgroundColor: []
    }
  ];
  
  public chartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      labels: {
        fontColor: "black",
      },
    },
  };
  //public chartColors: Color[] = [{ backgroundColor: 'blue' }];

  public chartData: ChartDataSets[] = [
    { data: [], 
      label: "Status", 
      fill: true 
    },
  ];
  public chartLabels: Label[] = [];

  @ViewChild(BaseChartDirective)
  public chart: any;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.chartLabels = []

    this.dateChartLabels.forEach((label: any) =>{
      if (label == AuthRoles_PTBR.resident){
       this.chartLabels.push(this.translate.instant("ROLES.RESIDENT"));
       this.donutColors[0].backgroundColor.push('rgba(0, 146, 206)');
      }
      if (label == AuthRoles_PTBR.employee){
       this.chartLabels.push(this.translate.instant("ROLES.EMPLOYEE"));
       this.donutColors[0].backgroundColor.push('rgba(107, 67, 155)');
      }
      if (label == AuthRoles_PTBR.visitor_residence){
       this.chartLabels.push(this.translate.instant("ROLES.VISITOR_RESIDENCE"));
       this.donutColors[0].backgroundColor.push('rgba(133, 202, 231)');
      }
      if (label == AuthRoles_PTBR.visitor_company){
        this.chartLabels.push(this.translate.instant("ROLES.VISITOR_COMPANY"));
        this.donutColors[0].backgroundColor.push('rgba(183, 165, 205)');
       }
       if (label == AuthRoles_PTBR.service_provider){
        this.chartLabels.push(this.translate.instant("ROLES.SERVICE_PROVIDER"));
        this.donutColors[0].backgroundColor.push('rgba(228,64,151)');
       }
    })

      this.chartData[0].data = this.countChartData;
      this.chartType = this.changeTypeChart;
      this.spinner = this.loadingChartData;
    
    if (this.countChartData == undefined) return;
    if (this.countChartData.length != 0) {
      this.containsAccessData = true;
    } else {
      this.containsAccessData = false;
    }
  }
}
